import React from "react";
import { useTranslation } from "react-i18next";

function DataSheet({ result }) {
  const { t } = useTranslation();
  const cautionLink = result["caution_link"].raw;
  const datasheetLink = result["data_sheet_link"].raw;
  return (
    <td>
      {datasheetLink && (
        <a href={result["data_sheet_link"].raw} target="_blank">
          {t("Datasheet")}
        </a>
      )}
      <br />
      {cautionLink && (
        <a href={cautionLink} target="_blank" rel="noopener noreferrer">
          {t("Precaution")}
        </a>
      )}
    </td>
  );
}
export default DataSheet;
